export const FirebaseConfig = {
	"projectId": "exicubetaxi",
	"appId": "1:1072628034317:web:3bae2680acb90ff6b19e44",
	"databaseURL": "https://exicubetaxi-default-rtdb.firebaseio.com",
	"storageBucket": "exicubetaxi.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyBdRoPYDf43Elhk-zdO_EOq0qxSREU0ylM",
	"authDomain": "exicubetaxi.firebaseapp.com",
	"messagingSenderId": "1072628034317",
	"measurementId": "G-6C1FYQV6X8",
	"projectNumber": "1072628034317",
	"version": "2"
};